import { render, staticRenderFns } from "./navigators.vue?vue&type=template&id=64da4ca2&scoped=true&"
import script from "./navigators.vue?vue&type=script&lang=js&"
export * from "./navigators.vue?vue&type=script&lang=js&"
import style0 from "./navigators.vue?vue&type=style&index=0&id=64da4ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da4ca2",
  null
  
)

export default component.exports